var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"express-sla"},[_c('div',{ref:"title",style:(("width:100%; height:" + (_vm.height ? _vm.height : '400px') + ";"))})])}
var staticRenderFns = []

export { render, staticRenderFns }